export default "__VITE_ASSET__BEyL775j__"